import React from "react";

import {
  NumberControl,
  NumberControlLabel,
  NumberControlInput,
  NumberControlArrows,
  NumberControlArrowButton,
  NumberControlReadOnlyValue,
} from "./styled";

const UpArrowIcon: React.FC = () => (
  <svg width="8" height="5" viewBox="0 0 8 5" fill="none">
    <path
      d="M1 4L4 1L7 4"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DownArrowIcon: React.FC = () => (
  <svg width="8" height="5" viewBox="0 0 8 5" fill="none">
    <path
      d="M1 1L4 4L7 1"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export interface QtyInputProps {
  value: number;
  onChange: (val: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  prefix?: string;
  suffix?: string;
}

export const QtyInput: React.FC<QtyInputProps> = ({
  value,
  onChange,
  min = 1,
  max = 24,
  disabled,
  prefix,
  suffix,
}) => {
  const clamp = (v: number) => Math.min(max, Math.max(min, v));
  return (
    <NumberControl disabled={disabled}>
      {prefix && <NumberControlLabel>{prefix}</NumberControlLabel>}
      <NumberControlInput
        type="number"
        min={min}
        max={max}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          const raw = e.target.value ? parseInt(e.target.value, 10) : NaN;
          if (Number.isNaN(raw)) return;
          onChange(clamp(raw));
        }}
      />
      {suffix && <NumberControlLabel>{suffix}</NumberControlLabel>}
      <NumberControlArrows>
        <NumberControlArrowButton
          type="button"
          disabled={disabled || value >= max}
          onClick={() => onChange(clamp(value + 1))}
          aria-label="Increase"
        >
          <UpArrowIcon />
        </NumberControlArrowButton>
        <NumberControlArrowButton
          type="button"
          disabled={disabled || value <= min}
          onClick={() => onChange(clamp(value - 1))}
          aria-label="Decrease"
        >
          <DownArrowIcon />
        </NumberControlArrowButton>
      </NumberControlArrows>
    </NumberControl>
  );
};

export interface ReadOnlyNumberProps {
  value: number | string;
  prefix?: string;
  suffix?: string;
  preset?: boolean;
}

export const ReadOnlyNumber: React.FC<ReadOnlyNumberProps> = ({
  value,
  prefix,
  suffix,
  preset,
}) => (
  <NumberControl preset={preset}>
    {prefix && <NumberControlLabel>{prefix}</NumberControlLabel>}
    <NumberControlReadOnlyValue>{value}</NumberControlReadOnlyValue>
    {suffix && <NumberControlLabel>{suffix}</NumberControlLabel>}
  </NumberControl>
);
